import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useBanner } from '../../context/BannerContext'

export const Banner = () => {
  const { isBannerVisible, dismissBanner } = useBanner()
  const location = useLocation()

  // Check if we're on the homepage
  const isHomepage = location.pathname === '/'

  // On homepage, always show banner; on other pages, respect dismissal
  const shouldShowBanner = isHomepage || isBannerVisible

  if (!shouldShowBanner) {
    return null
  }

  const handleDismiss = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    e.stopPropagation()
    dismissBanner()
  }

  return (
    <Link to="/scd-centers-workshop" className="flex w-full">
      <div className="bg-[#142841] text-[#EDE6DE] w-full flex justify-between items-center py-4 px-8 text-center text-base relative z-[1000] hover:cursor-pointer">
        <p className="m-0 flex-grow text-center">
          Applications are now open for the 2026 NASCC SCD Centers Workshop!
          Click here for more info!
        </p>
        {!isHomepage && (
          <button
            onClick={handleDismiss}
            className="bg-transparent border-none text-[#A0B2B4] text-2xl cursor-pointer p-0 px-2 leading-none absolute top-1/2 right-4 -translate-y-1/2 hover:text-white z-10"
            aria-label="Dismiss"
          >
            &times;
          </button>
        )}
      </div>
    </Link>
  )
}
